export const PAY_ONLINE = 'INTERVENTION/PAYMENT/PAY_ONLINE_REQUEST';
export const PAY_ONLINE_SUCCESS = 'INTERVENTION/PAYMENT/PAY_ONLINE_SUCCESS';
export const PAY_ONLINE_FAILURE = 'INTERVENTION/PAYMENT/PAY_ONLINE_FAILURE';

export const PAY_DEPOSIT = 'INTERVENTION/PAYMENT/PAY_DEPOSIT_REQUEST';
export const PAY_DEPOSIT_SUCCESS = 'INTERVENTION/PAYMENT/PAY_DEPOSIT_SUCCESS';
export const PAY_DEPOSIT_FAILURE = 'INTERVENTION/PAYMENT/PAY_DEPOSIT_FAILURE';

export const ANSWER_WORKS = 'INTERVENTION/WORKS/ANSWER_WORKS_REQUEST';
export const ANSWER_WORKS_SUCCESS = 'INTERVENTION/WORKS/ANSWER_WORKS_SUCCESS';
export const ANSWER_WORKS_FAILURE = 'INTERVENTION/WORKS/ANSWER_WORKS_FAILURE';

export const ACCEPT_AND_PAY_WORKS = 'INTERVENTION/WORKS/ACCEPT_AND_PAY_WORKS_REQUEST';
export const ACCEPT_AND_PAY_WORKS_SUCCESS = 'INTERVENTION/WORKS/ACCEPT_AND_PAY_WORKS_SUCCESS';
export const ACCEPT_AND_PAY_WORKS_FAILURE = 'INTERVENTION/WORKS/ACCEPT_AND_PAY_WORKS_FAILURE';

export const CALL_ME_BACK = 'INTERVENTION/GENERAL/CALL_ME_BACK_REQUEST';
export const CALL_ME_BACK_SUCCESS = 'INTERVENTION/GENERAL/CALL_ME_BACK_SUCCESS';
export const CALL_ME_BACK_FAILURE = 'INTERVENTION/GENERAL/CALL_ME_BACK_FAILURE';

export const SEND_OPINION = 'INTERVENTION/GENERAL/SEND_OPINION_REQUEST';
export const SEND_OPINION_SUCCESS = 'INTERVENTION/GENERAL/SEND_OPINION_SUCCESS';
export const SEND_OPINION_FAILURE = 'INTERVENTION/GENERAL/SEND_OPINION_FAILURE';

export const SEND_CONTACT_FORM = 'INTERVENTION/GENERAL/SEND_CONTACT_FORM_REQUEST';
export const SEND_CONTACT_FORM_SUCCESS = 'INTERVENTION/GENERAL/SEND_CONTACT_FORM_SUCCESS';
export const SEND_CONTACT_FORM_FAILURE = 'INTERVENTION/GENERAL/SEND_CONTACT_FORM_FAILURE';

export const RESET_CONTACT_FORM = 'INTERVENTION/GENERAL/RESET_CONTACT_FORM';

export const DOWNLOAD_MEDIAS = 'INTERVENTION/GENERAL/DOWNLOAD_MEDIAS_REQUEST';
export const DOWNLOAD_MEDIAS_SUCCESS = 'INTERVENTION/GENERAL/DOWNLOAD_MEDIAS_SUCCESS';
export const DOWNLOAD_MEDIAS_FAILURE = 'INTERVENTION/GENERAL/DOWNLOAD_MEDIAS_FAILURE';

export const GET_ZIP_MEDIAS = 'INTERVENTION/GENERAL/GET_ZIP_MEDIAS_REQUEST';
export const GET_ZIP_MEDIAS_SUCCESS = 'INTERVENTION/GENERAL/GET_ZIP_MEDIAS_SUCCESS';
export const GET_ZIP_MEDIAS_FAILURE = 'INTERVENTION/GENERAL/GET_ZIP_MEDIAS_FAILURE';

export const FETCH_PDF_OFFER = 'FETCH_PDF_OFFER';
export const FETCH_PDF_OFFER_SUCCESS = 'FETCH_PDF_OFFER_SUCCESS';
export const FETCH_PDF_OFFER_FAILURE = 'FETCH_PDF_OFFER_FAILURE';

export const SET_CONTROL_REPORT_FILTER = 'INTERVENTION/CONTROL_REPORT/SET_FILTER';

// There is no success as we are redirected to the payment page
export const PAY_FINAL_INVOICE = 'INTERVENTION/FINAL_INVOICE/PAY/REQUEST';
export const PAY_FINAL_INVOICE_SUCCESS = 'INTERVENTION/FINAL_INVOICE/PAY/SUCCESS';
export const PAY_FINAL_INVOICE_FAILURE = 'INTERVENTION/FINAL_INVOICE/PAY/FAILURE';

export const FETCH_PAYMENTS = 'INTERVENTION/PAYMENTS/FETCH_PAYMENTS_REQUEST';
export const FETCH_PAYMENTS_SUCCESS = 'INTERVENTION/PAYMENTS/FETCH_PAYMENTS_SUCCESS';
export const FETCH_PAYMENTS_FAILURE = 'INTERVENTION/PAYMENTS/FETCH_PAYMENTS_FAILURE';
